export default "__VITE_ASSET__Cge73yEh__"